export default "__VITE_ASSET__67333787__"